import { ReactNode } from 'react';
import { Typography } from '@uigovpe/components';

interface LabeledValueProps {
  label: ReactNode;
  value?: ReactNode;
}

/** Par rótulo/valor da revisão e do detalhe. Um componente só para os dois. */
export function LabeledValue({ label, value }: LabeledValueProps) {
  const empty = value === null || value === undefined || String(value).trim() === '';

  return (
    <div className="cd-labeled-value">
      <Typography variant="span" size="sm" className="cd-labeled-value__label">
        {label}
      </Typography>
      <Typography variant="span" size="default">
        {empty ? '—' : value}
      </Typography>
    </div>
  );
}
